import React, { useEffect, useState } from "react";
// import HeaderOne from "../components/HeaderOne";
// import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, } from 'swiper';
// install Swiper modules
// import FooterAreaOne from "../../components/FooterAreaOne";
/* import Breadcrumb from "../components/Breadcrumb";
import SubscribeOne from "../components/SubscribeOne";
import ContactArea from "../components/ContactArea"; */
import './index.scss';
import axios from 'axios';
import Preloader from "../../helper/Preloader";

import ba_r1 from './images/index/ba_r1.png';
import ba_r2 from './images/index/ba_r2.png';
import ba_r3 from './images/index/ba_r3.png';
import ba_r4 from './images/index/ba_r4.png';
import ba_r5 from './images/index/ba_r5.png';
import ba_r6 from './images/index/ba_r6.png';

import arrow_left from "./images/index/arrow-left.png"
import arrow_right from "./images/index/arrow-right.png"
import arrow_down from "./images/index/arrow-down.png"

// import sensors from '../../sensorsdata.es6.min.js';
import "animate.css";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import TextCon from '../../textContent';

import Header from '../component/header'
import SubMenu from "../component/menu/menu.jsx";
import Footer from "../component/footer";
SwiperCore.use([Navigation, Pagination, Scrollbar]);

let url = 'https://www.jingankerrycentre.com';
if (window.location.origin.includes('www.jingankerrycentre.com')) {
  url = 'https://www.jingankerrycentre.com';
}
if (window.location.origin.includes('qa-jakc-www.kerryplus.com')) {
  url = 'https://qa-jakc-www.kerryplus.com';
}

let cookieLeft = (document.documentElement.clientWidth - 760) / 2;
let cookieTop = (document.documentElement.clientHeight - 240) / 2;

const ContactPage = () => {
  let [active, setActive] = useState(true);
  const [list, setList] = useState([]);
  const [lang, setLang] = useState('zh');
  const [agreeCookies, setAgreeCookies] = useState(true);

  const rList = [ba_r1, ba_r2, ba_r3, ba_r4, ba_r5, ba_r6];

  useEffect( () => {
    setAgreeCookies(false);
    
    if (sessionStorage.getItem('agreeCookies')) {
      setAgreeCookies(true);
    } 
  }, [])

  useEffect(() => {
    if (sessionStorage.getItem('lang')) {
      setLang(sessionStorage.getItem('lang'));
    } else {
      getDefaultLang();
    }
    // console.log(sensors)
    getImages();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll)

  }, []);

  const getDefaultLang = () => {
    let lang = navigator.language||navigator.userLanguage; // 常规浏览器语言和IE浏览器
    // console.log('getDefaultLang', lang)
    // lang = lang.substr(0, 2); //截取lang前2位字符
    if(lang.includes('zh-CN')){
      setLang('zh');
    }else if (lang.includes('en')) {
      setLang('en');
    }else if (lang.includes('zh-TW')) {
      setLang('tzh');
    }
  }

  const handleScroll = () => {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // console.log(scrollTop)
    if (scrollTop > 0) {
      window.location.href = '/about';
    }
  }

  function getImages() {
    axios.get(`${url}/jeecg-boot/imgSetting/imgSetting/list?useType=index`).then( res => {
      // console.log(res.data)
      if (res.data.success) {
        let data = res.data.result ? res.data.result.records : [];
        setList(data);
        setActive(false);
      }
    }).catch( err => {
      // console.log(err)
      setActive(false);
    })
  }

  function getLang(lang) {
    console.log(lang, '--设置')
    setLang(lang);
  }

  const closeCookie = () => {
    setAgreeCookies(true);
  }

  // const closeWin = () => {
  //   if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
  //       window.location.href = "about:blank";
  //       window.close();
  //   } else {
  //       window.opener = null;
  //       window.open("", "_self");
  //       window.close();
  //   };
  // }
  
  const acceptCookies = () => {
    setAgreeCookies(true);
    sessionStorage.setItem('agreeCookies', true);
    document.cookie = "cookie_consent=accepted; path=/; Secure; SameSite=Strict";
  }

  return (
    <div id="index-page">
      {active && <Preloader />}

      {!agreeCookies && <div className="cookie-consent-popup">
        <h4 className="cookie-consent-title">
          {TextCon['cookieTitle'][lang]}
        </h4>
        <div className="cookie-consent-top-wrapper">
          <div className="cookie-consent-message">
            {TextCon['cookieLine1'][lang]}{TextCon['cookieLine2'][lang]}{TextCon['cookieLine3'][lang]}{TextCon['cookieLine4'][lang]}
          </div>
          <button className="cookie-consent-accept-all"
            onClick={acceptCookies}
          >
            {TextCon['cookieAgree'][lang]}
          </button>
        </div>
      </div>}

      {/* {!agreeCookies && <div className="cookie-dialog"
        style={{top: cookieTop, left: cookieLeft}}
      >
        <div className="top-line"></div>
        <div className="cookie-title">{TextCon['cookieTitle'][lang]}</div>
        <div className="cookie-line1">{TextCon['cookieLine1'][lang]}</div>
        <div className="cookie-line2">{TextCon['cookieLine2'][lang]}</div>
        <div className="cookie-line3">{TextCon['cookieLine3'][lang]}</div>
        <div className="cookie-line4">{TextCon['cookieLine4'][lang]}</div>
        <div className="cookie-operation"> 
          <div className="cookie-agree"
            onClick={() => {
              setAgreeCookies(true);
              sessionStorage.setItem('agreeCookies', true);
            }}
          >
            {TextCon['cookieAgree'][lang]}
          </div>
          <div className="cookie-close"
            onClick={closeCookie}
          >
            {TextCon['cookieClose'][lang]}
          </div>
        </div>
      </div>} */}
      
      <Header 
        getLang={getLang} 
      />

      <SubMenu 
        onChange={() => { }} 
        currentTab={'home'} 
        hiddenMenu={() => { }} 
        subMenuShow={false}
        activeColor={'#F3EA00'}
        defaultColor={'#FFFFFF'}
        lang={lang}
      />
      
      {list.length > 0 && <Swiper
        spaceBetween={50}
        // navigation
        pagination
        scrollbar
        loop={true}
        modules={[Autoplay, Navigation, EffectFade]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        style={{ width: '100%', height: '100vh' }}
        effect="fade"
        navigation={{
          nextEl: ".arrow-right",
          prevEl: ".arrow-left",
        }}
        observer={true}
      >
         <img src={arrow_left} alt="" className="arrow-left" />
         <img src={arrow_right} alt="" className="arrow-right" />
        {list.map((v, i) => {
          return <SwiperSlide style={{ position: 'relative' }} key={i}>
            {/* <ReactCSSTransitionGroup
              transitionEnter={true}
              transitionLeave={true}
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
              transitionName="animated"
            >
              <img src={rList[i]} className='ba_r_img animate__animated animate__fadeInRight' />
            </ReactCSSTransitionGroup> */}
            <img src={rList[i]} className='ba_r_img ' />
            <img src={v.imgUrl} alt="banner"
              style={{ width: '100%', height: '100%' }}
              className="swiper-img"
            />
          </SwiperSlide>
        })}

      </Swiper>}

      <div style={{borderBottom: '1px solid #fff'}}></div>

      <div className="arrow_down animate__animated animate__shakeY">
        <img src={arrow_down} style={{width: 30, height: 30}} />
      </div>
      

      <Footer 
        style={{ background: '#F3EA00' }} 
        lang={lang}
      />

    </div>
  );
};

export default ContactPage;
